"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _customProps = require("../../utils/customProps");

var _MuiDialog = _interopRequireDefault(require("../MuiDialog/MuiDialog"));

var _MuiIconButton = _interopRequireDefault(require("../MuiIconButton/MuiIconButton"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MuiIconButtonDialog = function MuiIconButtonDialog(_ref) {
  var dialog = _ref.dialog,
      iconButton = _ref.iconButton;

  var _useState = (0, _react.useState)({
    open: false
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var toggleDialog = function toggleDialog() {
    return setState(_objectSpread(_objectSpread({}, state), {}, {
      open: !state.open
    }));
  };

  var muiIconButton = iconButton[0];
  var muiDialog = dialog[0];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MuiIconButton.default, (0, _extends2.default)({}, muiIconButton, {
    onClick: toggleDialog
  })), /*#__PURE__*/_react.default.createElement(_MuiDialog.default, (0, _extends2.default)({}, muiDialog, {
    open: state.open,
    toggleDialog: toggleDialog
  })));
};

var _default = MuiIconButtonDialog;
exports.default = _default;
MuiIconButtonDialog.propTypes = {
  /** MuiDialog Allowed maximum: 1 */
  dialog: function dialog(props, propName, componentName) {
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, ['MuiDialog'], 1);
  },

  /** MuiIconButton Allowed maximum: 1 */
  iconButton: function iconButton(props, propName, componentName) {
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, ['MuiIconButton'], 1);
  }
};
MuiIconButtonDialog.defaultProps = {
  dialog: [],
  iconButton: []
};